import { useContext } from "react";
import styles from "./styles.module.scss";
import { MSTContext } from "../../stores/main";
import { ForkIcon } from "../../icons-and-animations/Icons";
import { observer } from "mobx-react-lite";
import Title from "antd/es/typography/Title";
import { getENV } from "../../stores/consts";

const FlowPage = observer(() => {
  const {
    platformStore: { projectWorkspaceVersion },
  } = useContext(MSTContext);

  function openFlowMapOnPlatform() {
    const env = getENV();
    window.open(
      `https://${
        env === "dev" || env === "staging" ? "dev." : ""
      }platform.blings.io/project/${projectWorkspaceVersion?.id}/flow-map`,
      "_blank"
    );
  }

  return (
    <div className={styles["flow-container"]}>
      <Title level={3} className={styles["flows-title"]}>
        We know flows are important
      </Title>
      <p className={styles["flows-description"]}>
        We have an improved and more intuitive flow creation experience in the
        platform
      </p>
      <button
        className={styles["open-flow-map-button"]}
        onClick={openFlowMapOnPlatform}
      >
        <ForkIcon />
        <p className={styles["open-flow-map-button-text"]}>
          Explore new flow builder
        </p>
      </button>

      <p className={styles["flows-small-description"]}>
        This action will open the flow map on a new tab
      </p>
    </div>
  );
});
export default FlowPage;
